import { getCurrencyConfig, getCurrencySymbol, getCurrencySymbolPosition, SYMBOL_POSITION, DEFAULT_SEPARATOR_PATTERN } from '../config';
import { formatNumber } from '../formatNumber';
import { ifNumberValidThen } from '../utils';
export function formatCurrencyNumber(code, input, options) {
  var _a = typeof options === 'object' ? options : {
      precision: options,
      maxPrecision: undefined,
      noSeparator: undefined
    },
    precision = _a.precision,
    maxPrecision = _a.maxPrecision,
    noSeparator = _a.noSeparator;
  var conf = getCurrencyConfig(code);
  var formattedNumber = conf ? formatNumber(input, {
    decimalPoint: conf.decimalPoint,
    separator: noSeparator ? void 0 : conf.separator,
    separatorPattern: noSeparator ? void 0 : typeof conf.separatorPattern === undefined ? DEFAULT_SEPARATOR_PATTERN : conf.separatorPattern,
    maxPrecision: ifNumberValidThen(maxPrecision, function (p) {
      return p;
    }, maxPrecision === false ? maxPrecision : conf.maxPrecision),
    precision: ifNumberValidThen(precision, function (p) {
      return p;
    }, precision === false ? precision : conf.precision)
  }) : formatNumber(input);
  var isTH = code === 'THB' || code === 'TH';
  var isDefaultTHCurrencySetting = precision === undefined;
  if (isTH && isDefaultTHCurrencySetting) {
    if (typeof formattedNumber === 'string' && !!/\.\d$/.exec(formattedNumber)) {
      formattedNumber += '0';
    }
  }
  return formattedNumber;
}
export function formatCurrency(code, input, options) {
  var num = typeof input === 'number' ? input : parseFloat(input);
  var isNegative = num < 0;
  var symbol = options && typeof options === 'object' && typeof options.symbol === 'string' ? options.symbol : getCurrencySymbol(code);
  var symbolPosition = options && typeof options === 'object' && typeof options.symbolPosition === 'string' ? options.symbolPosition : getCurrencySymbolPosition(code);
  var formattedNumber = String(formatCurrencyNumber(code, Math.abs(num), options));
  var sign = isNegative ? '-' : '';
  if (symbolPosition === SYMBOL_POSITION.BACK) {
    return sign + formattedNumber + symbol;
  } else {
    return sign + symbol + formattedNumber;
  }
}